import React from "react";
import "./PrivateTagSkillListing.css";
import { Avatar,Tooltip } from "antd";
import { UserOutlined } from "@ant-design/icons";

const PrivateTagSkillListing = ({tooltipPlacement='bottom',...props}) => {
    let userProfile = JSON.parse(localStorage.getItem("userProfile"));

    
    return (
      <Tooltip placement={tooltipPlacement} title="This is a private candidate">
        {/* <p style={{ display: "none" }}></p> */}
        <div className="PvtTag-Cantainer">
            <Avatar
                size={24}
                src={
                    userProfile?.Profiles?.PictureUrl
                        ? `${process.env.REACT_APP_S3_URL}${userProfile?.Profiles?.PictureUrl?.charAt(0) !== "/" ? "/" : ""
                        }${userProfile?.Profiles?.PictureUrl}`
                        : null
                }
            >
                {userProfile?.Profiles?.PictureUrl
                    ? null
                    : userProfile?.Profiles?.FirstName
                        ? userProfile?.Profiles?.FirstName[0]?.toUpperCase()
                        : ""}
            </Avatar>
        </div>
      </Tooltip>
    );
};

export default PrivateTagSkillListing;
